import type { PdfTableColumn, PdfTableExportOptions } from "../../../shared/services/export/pdf/pdfExport.types";
import type { SwimmerReportDataItem } from "../../../api/client/types/swimmer.types";

/**
 * PDF column definitions for the swimmers report.
 * Widths mirror backend `get_swimmers_columns()` exactly so proportions
 * match the Excel export.
 */
export const SWIMMERS_PDF_COLUMNS: PdfTableColumn<SwimmerReportDataItem>[] = [
  { header: "FECHA",                         accessor: (r) => r.registration_timestamp.split(" ")[0],              widthWeight: 16, align: "CENTER" },
  { header: "UNIDAD",                        accessor: (r) => r.building_name,                   widthWeight: 28, align: "LEFT"   },
  { header: "SALVAVIDAS",                    accessor: (r) => r.lifeguard_name,                  widthWeight: 30, align: "LEFT"   },
  { header: "NOMBRE Y APELLIDO DEL BAÑISTA", accessor: (r) => r.swimmer_name,                    widthWeight: 25, align: "LEFT"   },
  { header: "TORRE",                         accessor: (r) => r.building_tower,                  widthWeight:  9, align: "CENTER" },
  { header: "APTO",                          accessor: (r) => r.building_apartment,               widthWeight:  9, align: "CENTER" },
  { header: "TIPO DE USUARIO",               accessor: (r) => r.swimmer_type_name.toUpperCase(), widthWeight: 16, align: "LEFT"   },
  { header: "EDAD",                          accessor: (r) => r.age_classification_name.toUpperCase(), widthWeight: 28, align: "CENTER" },
  { header: "ADULTO RESPONSABLE",            accessor: (r) => r.responsible_name,                widthWeight: 24, align: "LEFT"   },
];

/**
 * Shared PDF layout options for the swimmers report.
 * Excludes per-call fields (`columns`, `rows`, `fileName`, `onError`).
 */
export const SWIMMERS_PDF_OPTIONS = {
  title: "CENTRAL DE COMUNICACIONES - REGISTRO DE BAÑISTAS",
  orientation: "landscape",
  format: "letter",
  headerFillColor: [255, 255, 0],
  logoUrl: "/report_logo.png",
  logoWidth: 16,
  fontSize: 6,
  cellPadding: 0.6,
  horizontalMargin: 20,
} satisfies Omit<PdfTableExportOptions<SwimmerReportDataItem>, "columns" | "rows" | "fileName" | "onError" | "onSuccess">;
